'use client';

import { Fragment } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import { CompanyPageImages } from '../markupConfig';

import { AppImageClient } from '@/shared/components/appImage';
import { useIsMobile } from '@/shared/hooks';

interface HandbookTabContentProps {
  pageTranslations: Record<string, string>;
  images: CompanyPageImages;
}
const HandbookBlock1: React.FC<HandbookTabContentProps> = ({
  pageTranslations,
  images,
}) => (
  <div className="bg-surface-base-secondary max-lg:bg-surface-base-secondary relative h-full min-h-[472px] w-full rounded-[20px] px-5 pt-[344px] pb-[10px] max-lg:min-h-[318px] max-lg:overflow-hidden max-lg:rounded-[20px] max-lg:pt-[210px]">
    <AppImageClient
      {...images.handbookTab1}
      alt="bg"
      className="absolute top-0 left-0 h-full w-full object-cover max-lg:h-auto max-lg:w-full"
    />
    <p
      id="handbookInfoText1"
      className="text-text-base-primary relative z-[1] text-[16px] leading-[24px] max-lg:text-[14px] max-lg:leading-[20px]"
    >
      {pageTranslations.handbookInfoText1}
    </p>
  </div>
);

const HandbookBlock2: React.FC<HandbookTabContentProps> = ({
  pageTranslations,
  images,
}) => (
  <div className="bg-surface-base-secondary max-lg:bg-surface-base-secondary relative h-full min-h-[472px] w-full rounded-[20px] px-5 pt-[344px] pb-[10px] max-lg:min-h-[357px] max-lg:overflow-hidden max-lg:rounded-[20px] max-lg:pt-[220px]">
    <AppImageClient
      {...images.handbookTab2}
      alt="bg"
      className="absolute top-0 left-0 h-full w-full object-cover max-lg:h-auto max-lg:w-full"
    />
    <p
      id="handbookInfoText2"
      className="text-text-base-primary relative z-[1] text-[16px] leading-[24px] max-lg:text-[14px] max-lg:leading-[20px]"
    >
      {pageTranslations.handbookInfoText2}
    </p>
  </div>
);

const HandbookBlock3: React.FC<HandbookTabContentProps> = ({
  pageTranslations,
  images,
}) => (
  <div className="bg-surface-base-secondary max-lg:bg-surface-base-secondary relative h-full min-h-[526px] w-full rounded-[20px] px-5 pt-[420px] pb-[10px] max-lg:min-h-[374px] max-lg:overflow-hidden max-lg:rounded-[20px] max-lg:pt-[270px]">
    <AppImageClient
      {...images.handbookTab3}
      alt="bg"
      className="absolute top-0 left-0 h-full w-full object-cover max-lg:h-auto max-lg:w-full"
    />
    <p
      id="handbookInfoText3"
      className="text-text-base-primary relative z-[1] text-[16px] leading-[24px] max-lg:text-[14px] max-lg:leading-[20px]"
    >
      {pageTranslations.handbookInfoText3}
    </p>
  </div>
);
export const HandbookTabContent: React.FC<HandbookTabContentProps> = ({
  pageTranslations,
  images,
}) => {
  const isMobile = useIsMobile();
  const contentList = [
    {
      id: 'handbookBlock1',
      content: (
        <HandbookBlock1 pageTranslations={pageTranslations} images={images} />
      ),
    },
    {
      id: 'handbookBlock2',
      content: (
        <HandbookBlock2 pageTranslations={pageTranslations} images={images} />
      ),
    },
    {
      id: 'handbookBlock3',
      content: (
        <HandbookBlock3 pageTranslations={pageTranslations} images={images} />
      ),
    },
  ];
  if (isMobile) {
    return (
      <Swiper spaceBetween={12} slidesPerView="auto" className="!px-5 !py-2">
        {contentList.map((content) => (
          <SwiperSlide key={content.id}>{content.content}</SwiperSlide>
        ))}
      </Swiper>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-[32px] max-lg:flex max-lg:flex-col">
      {contentList.map((content) => (
        <Fragment key={content.id}>{content.content}</Fragment>
      ))}
    </div>
  );
};
